module.exports = require("babel-core/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/polyfill.js
 ** module id = 376
 ** module chunks = 1
 **/